import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../providers/shared.service';
import { StorageService } from '../../../providers/storage.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '../../../providers/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'sm-block-unblock-reported',
  templateUrl: './block-unblock-reported.component.html',
  styleUrls: ['./block-unblock-reported.component.scss']
})
export class BlockUnblockReportedComponent implements OnInit, OnDestroy {
  addDiscountForm : FormGroup;
  type : string = ''
  blockStatus: any
  filteredList: any[] = []
  toCancelDocId:string = ''
formattedAddress: any = ''
entityHash: any = ''
  isMerchantSpecific:Boolean=false;
  isLocationSpecific:Boolean=false;
  isAllMerchant:Boolean=false;
  selectedMerchant:any=[];
  suggestedMerchant:any=[];
  isMerchantSelected:Boolean=false;
  entityList: any[] = [];
  objectoptions = [
    {name: 'angular'},
    {name: 'aise'}
  ]
  
  private apiSubscription: Subscription = new Subscription();
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private sharedService: SharedService,private storageService : StorageService ,public dialog: MatDialogRef<BlockUnblockReportedComponent>, private _apiservice: ApiService, private router: Router) { 
    this.addDiscountForm = new FormGroup({
     
      'cancellationNotes' : new FormControl(null,[Validators.required]),
      
  });

 
  }



  ngOnInit(): void {

console.log(this.data);


    


    
  }

  cancelVerification(){
 
    if(this.data.requestTypeInfo.requestType == "Business Profile"){
      this.type= 'business'
      this.blockStatus = 0
    
    }
    if(this.data.requestTypeInfo.requestType == "User Profile"){
      this.type= 'user'
      this.blockStatus = 2
      
    }
    if(this.data.requestTypeInfo.requestType == "User Post"){
      this.type= 'post'
      this.blockStatus = 4
    }

if(this.data.type == 'block'){
  const requestInfo = {
    hash_id: this.data.hash_id,
    requestType: this.data.requestTypeInfo.requestType,
    requestToHash: this.data.requestTypeInfo.hash_id,
    requestStatus: 9,
 

  }
  const blockUnblockInfo = {
   type: this.type,
   reason: this.addDiscountForm.value.cancellationNotes,
   status: this.blockStatus,
   incidentId: this.data.hash_id,
   hashId: this.data.requestTypeInfo.profile_hash_id ? this.data.requestTypeInfo.profile_hash_id : this.data.requestTypeInfo.hash_id

  }
  console.log({requestInfo});
  console.log(blockUnblockInfo);

  this._apiservice.updateUserRequestStatus({requestInfo});
  this._apiservice.blockUnblockOperation(blockUnblockInfo)
  this.dialog.close();
  setTimeout(() => {
    this.sharedService.sendClickEvent();
  }, 2000);
}


else if(this.data.type == 'unblock'){
  const requestInfo = {
    hash_id: this.data.hash_id,
    requestType: this.data.requestTypeInfo.requestType,
    requestToHash: this.data.requestTypeInfo.hash_id,
    requestStatus: 1,
 

  }

  const blockUnblockInfo = {
    type: this.type,
    reason: this.addDiscountForm.value.cancellationNotes,
    status: 1,
    incidentId: this.data.hash_id,
    hashId: this.data.requestTypeInfo.profile_hash_id ? this.data.requestTypeInfo.profile_hash_id : this.data.requestTypeInfo.hash_id

 
   }
  console.log({requestInfo});
  console.log(blockUnblockInfo);

  this._apiservice.updateUserRequestStatus({requestInfo});
  this._apiservice.blockUnblockOperation(blockUnblockInfo)
  this.dialog.close();
  setTimeout(() => {
    this.sharedService.sendClickEvent();
  }, 2000);
}




  }


  public closePopup(): void {
    this.dialog.close();
  }

  ngOnDestroy(): void {
    this.apiSubscription.unsubscribe();
  }

}
